import { Box } from '@mui/material'
import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'
import { getComp } from 'src/utils/utils/DI'
import LinksToInstallationReport from 'src/views/Service/components/Drawers/DrawersCommonComponents/LinksToInstallationReport'
import DataUnit from '../../../../../components/customElements/DataUnit/DataUnit'
import OrderStatus from '../../../../../components/customElements/RequestDataAccordions/OrderStatus'
import ReportChangeStatus from '../../../../../components/reports/ReportChangeStatus'
import {
  isAdmin,
  isDealer,
  isOperator,
} from '../../../../../services/AccountService'

const StatusInfoAndEdit = ({
  currentServiceData,
  serviceStore,
  hardCodeStatus,
  ordersStore,
  openRequestDetails,
  tab,
}) => {
  const userStore = getComp('UserInfoStore')
  const [isEdit, setIsEdit] = useState(false)
  const [installedOrderDealerId, setInstalledOrderDealerId] = useState(
    userStore.userId,
  )

  const handleChangeStatus = () => {
    setIsEdit(!isEdit)
    serviceStore?.toggleDisabledBtnSubmitRequest(!isEdit)
    serviceStore.setToggleStatusOnly()
  }

  const onEditStatusAdmin = () => {
    return getShowUserRejectBtn(currentServiceData?.status, tab)
  }

  return isEdit ? (
    <Box
      mb={1.5}
      mx={2}
      sx={{
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <OrderStatus
        status={hardCodeStatus || currentServiceData.status}
        isService={true}
        onEdit={handleChangeStatus}
      />
      <ReportChangeStatus
        closeChange={handleChangeStatus}
        currentServiceData={currentServiceData}
        store={serviceStore}
        selectedTab={tab}
      />
    </Box>
  ) : (
    <Box sx={{ paddingLeft: '10px' }}>
      <Box sx={{ display: 'flex' }}>
        <OrderStatus
          status={hardCodeStatus || currentServiceData.status}
          isService={true}
          onEdit={
            (onEditStatusAdmin() || currentServiceData.isTakenByMe) &&
            handleChangeStatus
          }
          styleEdit={
            isAdmin() &&
            (currentServiceData.status === 7 ||
              currentServiceData.status === 11) &&
            currentServiceData?.installedOrderId
          }
        />
        {isDealer() && installedOrderDealerId === userStore.userId && (
          <LinksToInstallationReport
            currentServiceData={currentServiceData}
            setInstalledOrderDealerId={setInstalledOrderDealerId}
          />
        )}
      </Box>
      {currentServiceData.status === 6.4 ||
      currentServiceData.status === 6.5 ? (
        <Box mb={1.5} mx={2} sx={{ flexGrow: 1 }}>
          <DataUnit
            name='№ заявки в сервис-центре'
            value={currentServiceData.externalTrackingNumber || 'Не заполнен'}
          />
        </Box>
      ) : null}
    </Box>
  )
}

const getShowUserRejectBtn = (status, tab) => {
  switch (true) {
    case isAdmin() && [1, 4, 5, 7, 8, 11, 20, 21, 24].includes(status):
      return true

    case isOperator() && [1, 20, 21].includes(status):
      return tab !== 3

    default:
      return false
  }
}
export default inject('serviceStore')(observer(StatusInfoAndEdit))
